import { CREATE_FILTER } from './filter-forms-action';

const initialState = {
  frm_Ecritures: {
    selecterDate: null,
    scope: null,
    state: null,
    label: null,
    dateFilter: {
      start_date: null,
      end_date: null,
    },
  },

  frm_ComptaRegle: {
    code: null,
    name: null,
    manual_auto: null,
    order: null,
    state: null,
  },
  frm_Rappro: {
    scope_id: '',
    company_id: '',
    account_id: '',
    category_id: '',
    search_type: '',
    dateCloture: '',
    mvt_a_rapprocher: {},
    ecriture_a_rapprocher: {},
  },
  frm_Mvt:{
    dateFilter: {
      start_date: null,
      end_date: null,
    },
    account_code: null,
    label: null,
    reference: null,
    categories: [],
    category: null,
    account_id: '',
    amount: null
  },
  frm_GenerationBrouillard:{
  
  }
};

// eslint-disable-next-line default-param-last
const fillterValueReducer = (state = initialState, action ) => {
  switch (action.type) {
    case CREATE_FILTER: {
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          ...action.payload.data,
        },
      };
    }

    default: {
      return { ...state };
    }
  }
};

export default fillterValueReducer;
